import { render, staticRenderFns } from "./AccomodationDetails.vue?vue&type=template&id=0f9c58c6&scoped=true"
import script from "./AccomodationDetails.vue?vue&type=script&lang=js"
export * from "./AccomodationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c58c6",
  null
  
)

export default component.exports